<!---->
 <!-- *ngIf="authService.isAuthenticated()" -->
<!-- <div class="container-fluid">
    <div class="row">
      <div class="col-md-12"> -->
          <!-- <div class="announcement">
              <p>Announcement Here!</p>
            </div> -->
         <router-outlet ></router-outlet>
        <!-- </div>
    </div>
  </div> -->
